var UgcVideo = class extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('video');
    this.playBtn = this.querySelector('[data-ugc-play]');
    this.pauseBtn = this.querySelector('[data-ugc-pause]');

    if (!this.video) return;

    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));

    if (this.playBtn) {
      this.playBtn.addEventListener('click', this.onPlay.bind(this));
    }
    if (this.pauseBtn) {
      this.pauseBtn.addEventListener('click', this.onPause.bind(this));
    }
  }

  onMouseEnter() {
    this.video.play().then(() => this.showPause()).catch(() => {});
  }

  onMouseLeave() {
    this.video.pause();
    this.video.currentTime = 0;
    this.showPlay();
  }

  onPlay(e) {
    e.stopPropagation();
    this.video.play().then(() => this.showPause()).catch(() => {});
  }

  onPause(e) {
    e.stopPropagation();
    this.video.pause();
    this.showPlay();
  }

  showPlay() {
    if (this.playBtn) this.playBtn.classList.remove('hidden');
    if (this.pauseBtn) this.pauseBtn.classList.add('hidden');
  }

  showPause() {
    if (this.playBtn) this.playBtn.classList.add('hidden');
    if (this.pauseBtn) this.pauseBtn.classList.remove('hidden');
  }
};

if (!window.customElements.get('ugc-video')) {
  window.customElements.define('ugc-video', UgcVideo);
}
